<template>
    <div>
      <EmployeeViewRequest/>
    </div>
  </template>
  
  <script>
    // @ is an alias to /src
    import EmployeeViewRequest from '@/components/EmployeeViewRequest.vue'
    
    export default {
      name: 'view-approved-request-view',
      components: {
        EmployeeViewRequest
      }
    }
  </script>
  